import debounce from 'lodash.debounce';

import { DataGridColsSettingsState } from '../types';

const saveToLocalStorage = debounce((persistSettingsId, state) => {
  localStorage.setItem(persistSettingsId, JSON.stringify(state));
}, 500);

type SavePersistColumnsSettingsParams = {
  persistSettingsId: string;
  state: DataGridColsSettingsState;
  onFail: (error: Error) => void;
};
export function savePersistColumnsSettings({
  persistSettingsId,
  state,
  onFail,
}: SavePersistColumnsSettingsParams) {
  if (!persistSettingsId) {
    return;
  }

  try {
    saveToLocalStorage(persistSettingsId, state);
  } catch (error) {
    onFail(error as Error);
  }
}

type ReadPersistColumnsSettings = {
  persistSettingsId: string;
};
export function readPersistColumnsSettings({
  persistSettingsId,
}: ReadPersistColumnsSettings): DataGridColsSettingsState | null {
  if (!persistSettingsId) {
    return null;
  }

  try {
    return JSON.parse(localStorage.getItem(persistSettingsId) ?? 'null');
  } catch (error) {
    return null;
  }
}
